import * as React from 'react';

export interface ISubmitMessageIconProps {
    className?: string;
}


export const SubmitMessageIcon: React.FC<ISubmitMessageIconProps> = (props: ISubmitMessageIconProps) => {
    return <span className={`submit-message-icon ${props.className ? props.className : ''}`}></span>
}